<template>
  <div class="graph-selector">
    <div class="input">
      <label class="input-label">Site</label>
      <multiselect
                   class="selectbox"
                   v-model="options.location"
                   :options="this.locations"
                   label="label"/>
    </div>
    <div class="input">
      <label class="input-label">Variety</label>
      <multiselect
                   class="selectbox"
                   v-model="options.variety"
                   :options="this.varieties"
                   label="label" />
    </div>
    <div class="input">
      <label class="input-label">Year</label>
      <multiselect
                   class="selectbox"
                   v-model="options.year"
                   :options="this.years"
                   label="label" />
    </div>
    <div class="input">
      <label class="input-label">View Mode</label>
      <multiselect
                   class="selectbox"
                   v-model="options.view"
                   :options="view_options"
                   label="label" />
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  components: { Multiselect },
  props: ['locations', 'varieties', 'years', 'value'],
  data() {
    return {
      options: {
        location: this.value.location,
        variety: this.value.variety,
        year: this.value.year,
        view: this.value.view,
      },
      view_options: [
        {
          value: 'skin',
          label: 'Skin Tannin',
        },
        {
          value: 'seed',
          label: 'Seed Tannin',
        },
        {
          value: 'skin-seed',
          label: 'Skin & Seed Tannin',
        },
      ],
    };
  },
  watch: {
    value: {
      handler() {
        this.options.location = this.value.location;
        this.options.variety = this.value.variety;
        this.options.year = this.value.year;
        this.options.view = this.value.view;
      },
      deep: true,
    },
    options: {
      handler() {
        this.$emit('input', this.options);
      },
      deep: true,
    },
  },
};
</script>

<style src="../assets/custom-multiselect-theme.css"></style>
<style lang="scss" scoped>
  @import '../assets/_colors.scss';
  @import '../assets/_globals.scss';
  @import '../assets/_common.scss';

  .graph-selector{
    color: $light-grey;
    background: #3b3b3b;
    margin-top: .5rem;
    padding:  .5rem .5rem 1rem .5rem;
    display: flex;

    @media screen and (max-width: $break-medium) {
        flex-direction: column;
    }
  }

  .input{
    flex: 1;
    padding: 0 .5rem;
    display: flex;
    flex-direction: column;

    &:first-child{
      @media screen and (max-width: $break-medium) {
        padding-top: 0;
      }
    }
    @media screen and (max-width: $break-medium) {
        padding-top: 1rem;
    }
  }

  .input-label{
    margin-bottom: .25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/SampleGraphSelector.vue